import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Tooltip } from '@/components/ui/Tooltip/Tooltip';
/**
 * コンサルサーチ：ページネーションのLabel表示用のコンポーネント
 * @param props
 * @constructor
 */
export const CSearchPaginateLabel = (props) => {
    const { disabled = false, value } = props;
    return (_jsx(Tooltip, Object.assign({ arrow: true, className: clsx('w-full h-full', 'flex justify-center items-center'), customStyle: { display: 'flex' }, html: disabled ? _jsx("span", { children: "\u4F1A\u54E1\u306E\u65B9\u306E\u307F\u95B2\u89A7\u53EF\u80FD" }) : undefined, isUnderHeaderComponent: true, zIndex: 0 }, { children: value })));
};
